const PaPaySetUpIcon = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9951 7.83536C15.9846 7.75836 15.9816 7.67886 15.9616 7.60436C15.8925 7.35035 15.8108 7.10135 15.588 6.93184C15.3571 6.67384 15.1793 6.37083 14.9118 6.14433C14.7501 5.94532 14.5883 5.74632 14.4265 5.54732C14.3188 5.37281 14.2728 5.17381 14.2001 4.98531C14.1961 4.7858 14.1916 4.5863 14.1876 4.3863C14.1896 4.01879 14.1901 3.65128 14.1931 3.28377C14.1946 3.12877 14.1491 2.98577 14.0849 2.84727C14.0514 2.62176 13.9061 2.45876 13.7679 2.29376C13.6537 2.15775 13.5135 2.00125 13.3728 1.94825C13.1053 1.84825 12.8068 1.80375 12.5118 1.80125C12.1117 1.79825 11.7115 1.79525 11.3118 1.80225C11.0514 1.80675 10.814 1.73275 10.5826 1.62574C10.1679 1.43324 9.88444 1.07473 9.53636 0.798728C9.14321 0.487222 8.82468 0.066714 8.26224 0.0132129C7.86608 -0.0247878 7.49245 0.0112129 7.15689 0.226717C6.72768 0.502222 6.37559 0.873729 5.99596 1.20924C5.57826 1.57824 5.13051 1.82525 4.54804 1.80725C4.08277 1.79275 3.61549 1.78225 3.14821 1.83225C2.58827 1.89225 1.98377 2.30726 1.85455 2.92377C1.84704 2.97877 1.80547 3.02027 1.80597 3.08077C1.80847 3.51578 1.80697 3.95079 1.80647 4.3858C1.79595 4.5733 1.78544 4.7608 1.77492 4.94781C1.69729 5.14731 1.65772 5.36181 1.54203 5.54732C1.34119 5.79582 1.14086 6.04383 0.940026 6.29233C0.75071 6.49584 0.561895 6.69884 0.404633 6.92934C0.136185 7.20185 -0.00254652 7.52585 0.00847186 7.91036C-0.0310941 8.28787 0.0680713 8.62538 0.302963 8.92338C0.549374 9.24989 0.824833 9.55189 1.09328 9.8599C1.25405 10.0604 1.41432 10.2609 1.57508 10.4614C1.6417 10.6479 1.70881 10.8349 1.77542 11.0214C1.78594 11.2089 1.79595 11.3964 1.80647 11.5839C1.80497 11.9499 1.80196 12.3159 1.80296 12.682C1.80296 12.8045 1.79345 12.93 1.85054 13.0455C1.97074 13.4465 2.20263 13.758 2.58176 13.9505C2.76857 14.094 2.98444 14.1655 3.21632 14.1685C3.71015 14.175 4.20497 14.1585 4.69879 14.1735C5.05038 14.1845 5.39395 14.2725 5.67242 14.4975C6.07509 14.823 6.46574 15.164 6.85189 15.5095C7.16391 15.7885 7.522 15.9775 7.93519 15.998C8.31983 16.017 8.68645 15.8995 8.99095 15.647C9.34054 15.357 9.69262 15.0685 10.0247 14.759C10.4544 14.359 10.9392 14.1385 11.5367 14.166C11.9173 14.1835 12.2995 14.1725 12.6811 14.168C12.914 14.1655 13.1369 14.115 13.3397 13.9935C13.7474 13.782 14.0409 13.4805 14.1165 13.0085C14.131 12.9755 14.1521 12.9435 14.1586 12.909C14.2402 12.4694 14.1891 12.0259 14.1936 11.5839C14.1976 11.3964 14.2157 11.2089 14.1916 11.0214C14.2723 10.8284 14.3529 10.6359 14.4335 10.4429C14.6178 10.1424 14.8838 9.9094 15.1006 9.63589C15.1587 9.57289 15.2218 9.51439 15.2739 9.44689C15.4647 9.19839 15.7227 8.99988 15.8424 8.69788C15.9731 8.42487 16.0137 8.13537 15.9961 7.83586L15.9951 7.83536Z"
        fill="#00B3DE"
      />
      <mask
        id="mask0_2817_13494"
        maskUnits="userSpaceOnUse"
        x="5"
        y="9"
        width="8"
        height="3"
      >
        <path
          d="M6.75975 9.57571L5.8418 11.2036H11.0817L12.0002 9.57571H6.75975Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2817_13494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.75975 9.57571L5.8418 11.2036H11.0817L12.0002 9.57571H6.75975Z"
          fill="white"
        />
      </g>
      <mask
        id="mask1_2817_13494"
        maskUnits="userSpaceOnUse"
        x="8"
        y="4"
        width="4"
        height="6"
      >
        <path
          d="M10.1628 9.57543H11.9999L8.91795 4.1138L8 5.74159L10.1628 9.57543Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_2817_13494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1628 9.57543H11.9999L8.91795 4.1138L8 5.74159L10.1628 9.57543Z"
          fill="white"
        />
      </g>
      <mask
        id="mask2_2817_13494"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="5"
        height="8"
      >
        <path
          d="M8.00008 7.37739L7.22153 8.75758H8.77863L8.00008 7.37739ZM8.91803 4.11377L4.91813 11.2033L4 9.5754L7.08152 4.11377H8.91803Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_2817_13494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00008 7.37739L7.22153 8.75758H8.77863L8.00008 7.37739ZM8.91803 4.11377L4.91813 11.2033L4 9.5754L7.08152 4.11377H8.91803Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default PaPaySetUpIcon;
